export const ORDER_LOCAL_STORAGE_KEY = {
    'RECIPIENT': 'recipientForm',
    'RECIPIENT_PACKAGE': 'recipientPackage',
    'SENDER': 'sender',
    'SENDER_FORM': 'senderForm',
    'TYPE_ORDER': 'typeOrder',
    'PICKUP_ORIGIN': 'pickupOrigin',
    'PACKAGE': 'package',
    'INVOICES': 'orderInvoices',
    'PAYMENT_DRAFT': 'createShipmentSeamlessGuest',
    'EDIT_INDEX': 'editIndex',
    'SAMEDAY': 'sameday',
    'SAMEDAY_FORM': 'samedayForm',
    'SHOW_SAMEDAY_TNC': 'showTnCSameday',
}
